import { writable } from "svelte/store"

export const sessionStore = writable({})
export const responsesStore = writable([])

export function syncSessionStores(exam_session) {
  sessionStore.set(exam_session)
  responsesStore.set(exam_session.responses)
}